import { types, actions } from './requests'
export const CREATERECIPE_TYPES = {
    ...types('CREATERECIPE'),
}
export const CREATERECIPE_ACTIONS = {
    ...actions('CREATERECIPE'),
}